import { axiosInstance as axios } from './index';

export const getCurrentUser = async (id: string) => {
  const { data } = await axios.get(`/users/${id}`);
  return data;
};
